import { Entity } from '@backstage/catalog-model';

export const RAILWAY_PROJECT_ID_ANNOTATION = 'railway.com/project-id';
export const RAILWAY_SERVICE_ID_ANNOTATION = 'railway.com/service-id';

export function isRailwayCostAvailable(entity: Entity): boolean {
  return Boolean(entity.metadata.annotations?.[RAILWAY_PROJECT_ID_ANNOTATION]);
}
